import { Mail, Phone, Headset } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { useSettings } from "@/context/SettingsContext";
import { SocialButtons } from "@/components/SocialButtons";

export const ContactCard = () => {
  const { t } = useLang();
  const { settings } = useSettings();
  const { contact_email: email, contact_phone: phone, telegram_link: tg, whatsapp_number: wa } = settings || {};
  if (!email && !phone && !tg && !wa) return null;
  return (
    <div className="rounded-2xl border border-border bg-card p-6" data-testid="dashboard-contact-card">
      <h2 className="flex items-center gap-2 text-lg font-bold"><Headset className="h-5 w-5 text-primary" />{t("contact_us")}</h2>
      <div className="mt-4 flex flex-col gap-2 text-sm sm:flex-row sm:flex-wrap sm:gap-6">
        {email && <a href={`mailto:${email}`} className="flex items-center gap-2 font-semibold hover:text-primary" data-testid="dashboard-contact-email"><Mail className="h-4 w-4" />{email}</a>}
        {phone && <a href={`tel:${phone}`} className="flex items-center gap-2 font-semibold hover:text-primary" data-testid="dashboard-contact-phone"><Phone className="h-4 w-4" />{phone}</a>}
      </div>
      <div className="mt-4"><SocialButtons testPrefix="dashboard" /></div>
    </div>
  );
};
